module.exports = __webpack_public_path__ + "pc/img/designer.520be6b6.png";